/*
,------.                                    ,--.          ,--.      ,--------.    ,------.            ,--.           
|  .-.  \,--. ,--.,--,--,  ,--,--.,--,--,--.`--' ,---.    |  | ,---.'--.  .--'    |  .-.  \  ,--,--.,-'  '-. ,--,--. 
|  |  \  :\  '  / |      \' ,-.  ||        |,--.| .--'    |  || .-. |  |  |       |  |  \  :' ,-.  |'-.  .-'' ,-.  | 
|  '--'  / \   '  |  ||  |\ '-'  ||  |  |  ||  |\ `--.    |  |' '-' '  |  |       |  '--'  /\ '-'  |  |  |  \ '-'  | 
`-------'.-'  /   `--''--' `--`--'`--`--`--'`--' `---'    `--' `---'   `--'       `-------'  `--`--'  `--'   `--`--' 
         `---'                                                                                                      
*/
import { VisionApplication } from '../../application';
import { VisionLayout } from '../../layout';
import { VisionFleetService } from './service';
import { FleetTabTrips } from './trips';
import { FleetTabDiagnostics } from './diagnostics';
import { NonReportingVehicleTab } from './nonreporting';

//===================================================================================================

export class VisionFleetTab {
    layout!: dhtmlXLayoutObject;
    service!: VisionFleetService;
    dataLayout!: dhtmlXLayoutObject;
    dataTabbar: dhtmlXTabBar;
    app: VisionApplication;

    nonReportingTab: NonReportingVehicleTab;
    tripsTab: FleetTabTrips;
    diagnosticTab!: FleetTabDiagnostics;

    initComplete: boolean;

    constructor(vision: VisionLayout) {
        this.app = vision.app;
        this.service = new VisionFleetService();
        this.initComplete = false;

        const config: IdhtmlXLayoutConfig = {
            parent: document.body,
            pattern: '1C',
        };
        this.layout = vision.tabbar.cells('FLEET').attachLayout(config);
        this.layout.cells('a').hideHeader();

        this.dataTabbar = this.layout.cells('a').attachTabbar();

        this.diagnosticTab = new FleetTabDiagnostics(this);
        this.nonReportingTab = new NonReportingVehicleTab(this);
        this.tripsTab = new FleetTabTrips(this);

        this.dataTabbar.attachEvent('onSelect', (id) => {
            if (id == 'diagnostics') {
                this.diagnosticTab.onSelect();
            } else if (id == 'trips') {
                this.tripsTab.onSelect();
            } else if (id == 'non-reporting') {
                this.nonReportingTab.update();
            }
            return true;
        });
    }

    public init() {
        if (this.initComplete == false) {
            this.dataTabbar.cells('diagnostics').setActive();
            this.diagnosticTab.updateDiagnostics();
            this.initComplete = true;
        }
    }
}
